<template>
	<svg viewBox="0 0 10 11" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
		<path d="M5 1V7M5 7L2.14286 4.33333M5 7L7.85714 4.33333M1 10H9" stroke="#1C4587" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
	</svg>
</template>

<script>
export default {
  name : 'icon-download'
};
</script>
